import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExternalLink = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_28617_3342)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M12.4441 9.77691V12.6658C12.4441 13.7704 11.5487 14.6658 10.4441 14.6658H3.33301C2.22844 14.6658 1.33301 13.7704 1.33301 12.6658V5.55469C1.33301 4.45012 2.22844 3.55469 3.33301 3.55469L6.2219 3.55469",
			stroke: "#002E5F",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M14.7044 1.20703L5.68848 10.223M14.7044 1.20703L8.88893 1.20704M14.7044 1.20703L14.7044 7.11189",
			stroke: "#002E5F",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_28617_3342",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgExternalLink);
export default ForwardRef;
